<template>
  <div class="fts-module-packages" :class="mediaBreakpoint">
    <!-- title -->
    <div class="module-package-title">
      Choose your template
    </div>
    <!-- search -->
    <div class="module-package-search">
      <!-- search input -->
      <fts-console-search-input
        v-model="searchKeyword"
        :loading="packageLoading" 
        @input:search="filter"
      />
    </div>
    <!-- package -->
    <template v-if="packagesLoaded">
      <div class="module-packages-container" :class="{loading: loading}">
        <fts-spinner :show="loading" class="module-packages-spinner" />
        <!-- package categories -->
        <div class="module-package-tag-container">
          <div :class="{ 'active': filteredCategory == '' }" class="module-package-tag" @click="filterCategory('')">
            All
          </div>
          <div
            class="module-package-tag"
            v-for="category in categories"
            :key="category"
            :class="{ 'active': filteredCategory == category }"
            @click="filterCategory(category)"
          >
            {{ category }}
          </div>
        </div>
        <!-- packages -->
        <template v-if="packages && packages.length">
          <div class="module-package-container">
            <div class="module-package-wrapper" v-for="x in packages" :key="x.id" @click="viewPackage(x)">
              <div 
                class="module-package-header"
                :style="{'background-image': getPackageBg(x.image && x.image.path)}"
                v-if="getPackageBg(x.image && x.image.path)"    
              >
              </div>
              <div class="module-package-header default" v-else>
                <fts-moji
                  :size="70"
                  :emoji="x.emoji" 
                  class="module-package-emoji" />
                <div class="module-package-name">
                  {{x.name}}
                </div>
              </div>
              <div class="module-package-category" v-if="x.category">{{x.category}}</div>
              <div class="module-package-content">
                <div class="module-package-row-alpha">
                  <div class="module-package-key">{{x.key || '(undefined)'}}</div>
                  <div class="module-package-version">{{x.version}}</div>
                </div>
                <div class="module-package-row-beta">
                  <fts-moji
                    :size="16"
                    :emoji="x.emoji"
                    class="module-package-emoji"
                    v-if="x.emoji" />
                  <div class="module-package-name">{{x.name}}</div>
                </div>
                <div class="module-package-desc">
                  {{x.description}}
                </div>
                <div class="module-package-actions">
                  <fts-btn
                    color="primary"
                    text
                    text-transform-init
                    class="module-package-action"
                    @click="viewPackage(x)">
                    view detail
                  </fts-btn>
                </div>
              </div>
            </div>
          </div>
          <!-- load more -->
          <div class="module-package-load-more" v-if="packageTotalItems > (packages && packages.length)">
            <fts-btn
              color="primary"
              outline
              text-transform-init
              rounded
              :loading="packageLoadMoreLoading"
              @click="loadMorePackages"
            >
              Load more
            </fts-btn>
          </div>
        </template>
        <!-- package no result -->
        <div class="module-package-no-result" v-else-if="!loading">
          <div class="no-result-label">No results found</div>
          <div class="no-result-desc">Try different search term</div>
        </div>
      </div>
    </template>
    <!-- skeleton -->
    <div class="module-package-container" v-else>
      <skeleton-module-package class="module-package-wrapper" />
      <skeleton-module-package class="module-package-wrapper" />
      <skeleton-module-package class="module-package-wrapper" />
      <skeleton-module-package class="module-package-wrapper" />
      <skeleton-module-package class="module-package-wrapper" />
      <skeleton-module-package class="module-package-wrapper" />
    </div>
    <!-- topics -->
    <!-- <div class="topic-container">
      <div class="topic-title">Community</div>
      <div class="topic-wrapper" v-for="x in topics" :key="x.id">
        <div 
          class="topic-l" 
          :style="{'background-image': `url(${x.image_url})`}"
          v-if="x.image_url">
        </div>
        <div 
          class="topic-l default"
          v-else>
          <fts-moji
            :size="90"
            emoji="📰"
            class="default-emoji" />
          <div class="default-label">{{x.title}}</div>
        </div>
        <div class="topic-r">
          <div class="topic-title">{{x.title}}</div>
          <div class="topic-desc">
            <span class="desc-content" v-html="x.excerpt"></span>
            <a 
              class="fts-link-primary topic-link" 
              :href="`https://community.fetias.com/t/${x.slug}/${x.id}`" 
              target="_blank">
              read more
            </a>
          </div>
          <div class="topic-audit">
            <div class="audit-by">
              <font-awesome-icon :icon="['far', 'user']" />
              <div>{{x.last_poster_username}}</div>
            </div>
            <div class="audit-date">
              <font-awesome-icon :icon="['far', 'calendar']" />
              <div>{{moment(x.last_posted_at || x.created_at).format('ll')}}</div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <a
          class="fts-link-primary"
          href="https://community.fetias.com"
          target="_blank"
          >read more on community</a
        >
      </div>
    </div> -->
    <!-- module package modal -->
    <fts-module-package-modal ref="ftsModulePackageModal" />
    <!-- feedback-indicate -->
  </div>
</template>

<script>
import moment from "moment";

import webAppConfig from "../commons/webApp.config";
import commons from "../commons/commons";

import FTSBtn from "../elements/FTSBtn";
import FTSModulePackageModal from "./FTSModulePackageModal";
import FTSConsoleSearchInput from "./console/FTSConsoleSearchInput";
import FTSMoji from "../elements/FTSMoji.vue";
import FTSSpinner from "../elements/FTSSpinner";
import SkeletonModulePackage from "../elements/skeleton-screen/module-package/SkeletonModulePackage";

const packagePageSize = 6;
let resizeObserver = null;

export default {
  components: {
    "fts-btn": FTSBtn,
    "fts-module-package-modal": FTSModulePackageModal,
    "fts-console-search-input": FTSConsoleSearchInput,
    "fts-moji": FTSMoji,
    "fts-spinner": FTSSpinner,
    "skeleton-module-package": SkeletonModulePackage,
  },
  data: () => ({
    mediaBreakpoint: null,
    packages: [],
    packageTotalItems: 0,
    packagePageSize: packagePageSize,
    packagesLoaded: false,
    
    packageLoading: false,
    categoryLoading: false,
    packageLoadMoreLoading: false,

    searchKeyword: null,
    categories: [],
    topics: [],
    filteredCategory: ''
  }),
  methods: {
    moment,
    async filter() {
      this.packageLoading = true;
      try {
        let res = await this.$store.dispatch("loadPackages", {
          pageSize: packagePageSize,
          category: this.filteredCategory,
          searchText: this.searchKeyword
        });
        this.packages = res.data.list;
        this.packageTotalItems = res.data.totalItems;
      } catch(err) {

      } finally {
        this.packageLoading = false;
      }
    },
    async filterCategory(category) {
      this.categoryLoading = true;
      this.filteredCategory = category;
      try {
        let res = await this.$store.dispatch("loadPackages", {
          pageSize: packagePageSize,
          category: this.filteredCategory,
          searchText: this.searchKeyword
        });
        this.packages = res.data.list;
        this.packageTotalItems = res.data.totalItems;
      } catch(err) {

      } finally {
        this.categoryLoading = false;
      }
    },
    async viewPackage(item) {
      const res = await this.$refs.ftsModulePackageModal.show(item);
      if (res != null && res != true) {
        setTimeout(async () => {
          this.$emit("package:installed");
          await this.$store.dispatch("loadVector", res.id);
          this.$store.dispatch("updateWorkspaceMenus");
          this.$router.push({
            query: { id: commons.encodeids(res.id) },
          });
        }, 300);
      }
    },
    getPackageBg(path) {
      if (path) {
        return `url('${webAppConfig.baseURL}${path}')`;
      }
    },
    async loadMorePackages() {
      this.packageLoadMoreLoading = true;
      try {
        let res = await this.$store.dispatch("loadPackages", {
          pageSize: this.packagePageSize += packagePageSize,
          category: this.filteredCategory,
          searchText: this.searchKeyword,
        });
        this.packages = res.data.list;
        this.packageTotalItems = res.data.totalItems;
      } catch(err) {
      

      } finally {
        this.packageLoadMoreLoading = false;
      }
    }
  },
  computed: {
    loading() {
      return this.packageLoading || this.categoryLoading;
    }
  },
  watch: {
    loading(val) {
      if (val && this.packagePageSize != packagePageSize)
        this.packagePageSize = packagePageSize;
    }
  },
  async mounted() {
    resizeObserver = new ResizeObserver(_.debounce((entries) => {
      const elOffsetWidth = entries[0].target.offsetWidth;
      if (elOffsetWidth >= 1527)
        this.mediaBreakpoint = "lg";
      else if (elOffsetWidth >= 1031)
        this.mediaBreakpoint = "md";
      else 
        this.mediaBreakpoint = "sm";
    }, this.packagesLoaded ? 500 : 0));

    resizeObserver.observe(this.$el);

    try {
      let res = await this.$store.dispatch("loadPackages", {
        pageSize: packagePageSize,
      });
      this.packages = res.data.list;
      this.packageTotalItems = res.data.totalItems;
      this.categories = res.data.categories;
      this.packagesLoaded = true;

      // let topicsResponse = await this.$store.dispatch("loadTopics");
      // const topics = topicsResponse.data.topic_list.topics;
      // if (topics && Array.isArray(topics))
      //   this.topics = topics.slice(0, 5);
    } catch (err) {
      console.error(err);
    }
  },
  beforeDestroy() {
    resizeObserver.unobserve(this.$el);
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-module-packages {
  max-width: 1536px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 1rem 2rem 2rem;
  /* breakpoint */
  $packageMediaBreakpoints:
    lg 25%,
    md 33.333333%,
    sm 50%;
  @each $name, $breakpoint in $packageMediaBreakpoints {
    &.#{$name} {
      .module-package-container {
        .module-package-wrapper {
          flex: 1 1 calc(#{$breakpoint} - 1rem);
          max-width: calc(#{$breakpoint} - 1rem);
        }
      }
    }
  }
  .module-package-title {
    margin-top: 1rem;
    margin-bottom: 2rem;
    font-weight: 500;
    font-size: 1.875rem;
    line-height: 2.25rem;
    text-align: center;
  }
  .module-package-search {
    max-width: 48rem;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2.5rem;
  }
  .module-packages-container {
    position: relative;
    min-height: 150px;
    &.loading {
      .module-package-tag-container .module-package-tag,
      .module-package-container .module-package-wrapper {
        position: relative;
        border-color: transparent;
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 1;
          opacity: .75;
          background: #fff;      
        }
      }
    }
    .module-packages-spinner {
      position: absolute;
      height: 100%;
      width: 100%;
      z-index: 2;
    }
  }
  .module-package-tag-container {
    @include flex-gap($gap: 0.375rem);
    padding-bottom: 1.5rem;
    .module-package-tag {
      cursor: pointer;
      padding: 0.375rem 0.75rem;
      background: $grayLightenColor;
      border-radius: 0.25rem;
      font-size: 0.875rem;
      color: #4c4c4c;
      text-decoration: unset;
    }
    .module-package-tag.active {
      background: $primaryColor;
      color: #ffffff;
    }
  }
  .module-package-container {
    @include flex-gap($gap: 1rem, $display: flex, $width: auto);
    .module-package-wrapper {
      position: relative;
      flex: 1 1 300px;
      display: flex;
      flex-direction: column;
      max-width: 300px;
      border: 1px solid $borderColor;
      border-radius: .375rem;
      background: #fff;
      cursor: pointer;
      .module-package-header {
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
        height: 150px;
        &.default {
          @include flex-center-middle;
          position: relative;    
          padding: 1rem;
          background: $primaryGradient;
          z-index: 1;
          .module-package-emoji {
            @include absolute-center-middle;
            opacity: .5;
            z-index: -1;
          }
          .module-package-name {
            @include text-line-clamp($fontSize: 1.5rem, $lineClamp: 2);
            text-align: center;
            font-weight: 600;
            color: #f5f5f5;
          }
        }
        &:not(.default) {
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
        }
      } 
      .module-package-category {
        position: absolute;
        top: .875rem;
        left: 1rem;
        padding: .175rem .275rem;
        border-radius: 2px;
        font-size: .75rem;
        font-weight: 500;
        background-color: var(--fts-ternary-blue);
        color: #fff;
        text-transform: uppercase;
        z-index: 1;
      }
      .module-package-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 1rem;
        .module-package-row-alpha {
          min-width: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 1rem;
        }
        .module-package-row-beta {
          min-width: 0;
          display: flex;
          align-items: center;
          margin-bottom: .375rem;
        }
        .module-package-emoji {
          margin-right: .575rem;
        }
        .module-package-name {
          @include text-overflow-ellipsis;
          flex: 1;
          font-size: 1.15rem;
          font-weight: 500;
        }
        .module-package-desc {
          @include text-line-clamp(
            $fontSize: 0.9rem,
            $lineClamp: 2,
            $lineHeight: 1.3
          );
          margin-bottom: 1rem;
          color: $grayLightColor;
        }
        .module-package-key {
          @include text-overflow-ellipsis;
          margin-right: 0.75rem;
          color: $grayColor;
          font-size: 0.875rem;
        }
        .module-package-version {
          color: $grayColor;
          font-size: 0.875rem;
        }
        .module-package-actions {
          margin-top: auto;
          .module-package-action {
            &:first-child {
              margin-left: -0.75rem;
            }
          }
        }
      }
    }
  }
  .module-package-load-more {
    margin-top: 2rem;
    margin-left: 2rem;
    margin-right: 2rem;
    text-align: center;
    > .fts-btn {
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
  }
  // .topic-container {
  //   margin-top: 2rem;
  //   .topic-title {
  //     margin-bottom: 1rem;
  //   }
  //   .topic-wrapper {
  //     min-width: 0;
  //     flex: 1 1 100%;
  //     display: flex;
  //     border: 1px solid $borderColor;
  //     border-radius: .375rem;
  //     background: #fff;
  //     &:not(:last-child) {
  //       margin-bottom: 1rem;
  //     }
  //     .topic-l {
  //       flex: 1 0 250px;
  //       max-width: 250px;
  //       min-height: 150px;
  //       border-top-left-radius: inherit;
  //       border-bottom-left-radius: inherit;
  //       &.default {
  //         @include flex-center-middle;
  //         position: relative;    
  //         padding: 1rem;
  //         background: $primaryGradient;
  //         z-index: 1;
  //         .default-emoji {
  //           @include absolute-center-middle;
  //           opacity: .5;
  //           z-index: -1;
  //         }
  //         .default-label {
  //           @include text-line-clamp($fontSize: 1.5rem, $lineClamp: 2);
  //           text-align: center;
  //           font-weight: 600;
  //           color: #f5f5f5;
  //         }
  //       }
  //       &:not(.default) {
  //         border-top-left-radius: inherit;
  //         border-bottom-left-radius: inherit;
  //         background-position: center center;
  //         background-repeat: no-repeat;
  //         background-size: cover;
  //       }
  //     }
  //     .topic-r {
  //       min-width: 0;
  //       flex: 1;
  //       display: flex;
  //       flex-direction: column;
  //       padding: 1.5rem 2rem;
  //       .topic-title {
  //         @include text-overflow-ellipsis;
  //         margin-bottom: .375rem;
  //         font-size: 1.35rem;
  //         font-weight: 600;
  //       }
  //       .topic-desc {
  //         margin-bottom: 1.5rem;
  //         font-size: 0.9rem;
  //         line-height: 1.3;
  //         .desc-content {
  //           color: $grayLightColor;
  //         }
  //         .topic-link {
  //           display: inline-flex;
  //           margin-top: .375rem;
  //         }
  //       }
  //       .topic-audit {
  //         display: flex;
  //         align-items: baseline;
  //         margin-top: auto;
  //         font-size: .875rem;
  //         color: $grayLightColor;
  //         .audit-by {
  //           max-width: 250px;
  //           > div {
  //             @include text-overflow-ellipsis;
  //           }
  //         }
  //         .audit-by,
  //         .audit-date {
  //           display: inline-flex;
  //           > svg {
  //             margin-right: .375rem;
  //           }
  //         }
  //         .audit-by + .audit-date {
  //           margin-left: 1.5rem;
  //         }
  //       }
  //     }
  //   }
  // }
  .module-package-no-result {
    @include flex-center-middle;
    flex-direction: column;
    min-height: 150px;
    .no-result-label {
      font-size: 1.15rem;
      font-weight: 600;
    }
    .no-result-desc {
      margin-top: .575rem;
      font-size: .875rem;
    }
  }
}
</style>